// extracted by mini-css-extract-plugin
module.exports = {"row":"style_row__1Le1B","column":"style_column__gPhmV","label":"style_label__2D3qJ","spacer_w16":"style_spacer_w16__393qf"};